import axios from 'axios';
import config from '../config';

const api = axios.create({
    baseURL: config.baseUrl,
    headers: {
        'APP_NAME': config.app_name,
        'APP_VERSION': config.version
    }
});

api.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem('token');
		if (token) {
			config.headers['Authorization'] = `Bearer ${token}`;
		} else {
			delete config.headers['Authorization'];
		}
		return config;
	},
	(error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.clear();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;
